export default __webpack_public_path__ + "static/media/楊得年.7ba92532.jpg";